var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M309.89 630.93C138.74 630.93 0 610.12 0 584.45C0 566.28 69.54 550.53 170.9 542.9C212.69 539.74 259.92 537.97 309.89 537.97C330.43 537.97 350.5 538.27 369.92 538.84C512.33 543.04 619.78 561.86 619.78 584.45C619.78 610.12 481.04 630.93 309.89 630.93Z",
    id: "c2Tsk0AARJ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.86 579.45C388.86 587.46 335.6 593.95 269.9 593.95C204.2 593.95 150.95 587.46 150.95 579.45C150.95 571.45 204.2 564.96 269.9 564.96C335.6 564.96 388.86 571.45 388.86 579.45Z",
    id: "a3NwRIqT3m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.86 469.99C381.86 536.24 331.51 589.95 269.4 589.95C207.29 589.95 156.94 536.24 156.94 469.99C156.94 403.74 207.29 350.04 269.4 350.04C331.51 350.04 381.86 403.74 381.86 469.99Z",
    id: "a5R1J7OZEw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.89 540.97C304.89 540.97 304.89 540.97 304.89 540.97C304.89 579.35 304.89 600.68 304.89 604.94C304.89 604.94 304.89 604.94 304.89 604.94C262.9 604.94 239.58 604.94 234.92 604.94C234.92 604.94 234.92 604.94 234.92 604.94C234.92 566.56 234.92 545.23 234.92 540.97C234.92 540.97 234.92 540.97 234.92 540.97C276.9 540.97 300.22 540.97 304.89 540.97Z",
    id: "b4hIZDhWG3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.36 578.45L418.35 582.45L435.34 572.46L434.34 556.46L396.36 556.46L396.36 556.46L392.36 578.45Z",
    id: "f2xuT3Z012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.41 167.6C258.41 167.6 269.4 208.59 269.4 208.59C271 208.59 279 208.59 293.39 208.59L312.39 203.59C306.99 190.39 303.99 183.06 303.39 181.6C303.39 181.6 291.39 165.6 300.39 152.61C309.39 139.61 265.4 143.61 265.4 143.61C264 148.41 263.4 166.6 258.41 167.6Z",
    id: "a1C4xFZpkw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.41 167.6C258.41 167.6 269.4 208.59 269.4 208.59C271 208.59 279 208.59 293.39 208.59L312.39 203.59C306.99 190.39 303.99 183.06 303.39 181.6C303.39 181.6 291.39 165.6 300.39 152.61C309.39 139.61 265.4 143.61 265.4 143.61C264 148.41 263.4 166.6 258.41 167.6Z",
    id: "c4ugWIHzTK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.42 319.55C215.42 319.55 189.43 369.53 210.42 379.52C210.42 379.52 236.41 388.52 236.41 391.52C236.41 391.52 232.42 393.52 234.42 398.52C234.42 398.52 230.42 423.51 236.41 435.5C236.41 435.5 240.41 456.5 240.41 456.5C240.41 456.5 240.41 457.5 242.41 461.49C242.41 461.49 245.41 468.49 244.41 470.49C244.41 470.49 237.41 485.49 243.41 488.48C243.41 488.48 280.4 493.48 283.4 488.48C283.4 488.48 280.4 480.49 283.4 477.49C283.4 477.49 288.4 473.49 286.4 471.49C286.4 471.49 282.4 444.5 282.4 444.5C282.4 444.5 287.4 415.51 285.4 411.51C285.4 411.51 280.4 403.52 282.4 400.52C282.4 400.52 286.4 398.52 287.4 394.52C287.4 394.52 290.39 381.52 290.39 381.52C291.13 381.46 294.79 381.12 301.39 380.52C316.99 383.52 325.65 385.19 327.38 385.52C327.38 385.52 356.37 417.51 388.36 427.51C388.36 427.51 397.36 436.5 400.36 436.5C403.35 436.5 403.35 436.5 402.35 438.5C401.35 440.5 398.36 440.5 400.36 442.5C402.35 444.5 405.35 441.5 403.35 444.5C401.35 447.5 399.36 447.5 401.35 449.5C403.35 451.5 400.36 462.49 400.36 463.49C400.36 464.49 391.36 558.46 394.36 560.46C397.36 562.46 439.34 568.46 442.34 560.46C445.34 552.46 440.34 542.47 440.34 542.47C440.34 542.47 455.34 422.51 451.34 414.51C447.34 406.51 433.34 370.53 358.37 347.54C358.37 347.54 337.38 343.54 337.38 340.54C337.38 337.54 335.38 318.55 331.38 317.55C327.38 316.55 304.39 315.55 304.39 315.55C302.46 316.15 292.79 319.15 275.4 324.54L235.41 317.55C224.75 318.61 218.09 319.28 215.42 319.55Z",
    id: "aGeRUfuTL"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.41 487.49C247.41 498.28 245.74 504.28 245.41 505.48C245.41 505.48 241.41 534.47 246.41 541.47C250.34 546.96 257.35 553.69 270.35 554.87C277.85 555.56 284.83 550.94 287.12 543.76C287.27 543.34 287.36 542.91 287.4 542.47C287.4 540.47 284.4 516.47 284.4 516.47C284.06 514.81 282.4 506.48 279.4 491.48L278.4 484.49L250.41 487.49Z",
    id: "e4jhw4gVS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.36 573.45C390.36 573.45 385.36 599.44 392.36 600.44C392.36 600.44 466.33 611.44 473.33 607.44C473.33 607.44 493.32 597.45 485.32 594.45C485.32 594.45 454.34 582.45 454.34 582.45C454.34 582.45 441.34 565.46 439.34 564.46C439.34 564.46 426.35 565.46 421.35 569.46C416.35 573.45 396.36 573.45 396.36 573.45C395.16 573.45 391.36 568.46 390.36 573.45Z",
    id: "aE2gm2KEo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.4 102.62C272.28 102.62 258.41 116.5 258.41 133.61C258.41 150.73 272.28 164.6 289.4 164.6C306.51 164.6 320.38 150.73 320.38 133.61C320.38 116.5 306.51 102.62 289.4 102.62Z",
    id: "gWOlvOa4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.4 190.59C266.42 175 261.99 166.33 261.1 164.6C261.1 164.6 251.41 161.6 249.41 166.6C249.41 166.6 211.42 187.59 211.42 187.59C211.42 187.59 220.42 271.56 216.42 279.56C216.42 279.56 205.43 319.55 211.42 322.54C211.42 322.54 245.41 322.54 254.41 326.54C254.41 326.54 289.4 330.54 296.39 325.54C296.39 325.54 305.39 316.55 312.39 319.55C318.34 322.1 332.27 234.82 336.28 208.81C336.97 204.35 335.07 199.89 331.37 197.3C322.4 191.01 306.25 180.17 303.39 181.6C299.39 183.6 286.4 203.59 286.4 203.59C284.8 201.86 280.8 197.52 274.4 190.59Z",
    id: "a1xLFbJk8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.38 199.59C334.19 200.79 337.74 204.86 338.29 209.78C339.1 217.06 345.57 275.28 346.37 282.56C346.37 282.56 326.38 325.54 316.39 296.55C306.39 267.56 329.38 199.59 329.38 199.59C329.38 199.59 329.38 199.59 329.38 199.59Z",
    id: "d1tjoFzcBe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.38 289.56C340.58 285.96 347.91 283.96 349.37 283.56C349.37 283.56 353.37 311.55 357.37 311.55C357.37 311.55 343.38 327.54 334.38 325.54C334.38 325.54 312.39 316.55 311.39 311.55C311.39 311.55 320.38 285.56 320.38 285.56C321.32 286.09 323.65 287.42 327.38 289.56Z",
    id: "d1hHoHK8AJ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.49 132.12C272.83 122.92 282.99 118.17 292.19 121.52C293.7 122.06 295.12 122.81 296.43 123.74C298.67 125.34 300.92 127.59 303.65 127.28C306.6 126.95 309.22 123.67 311.93 124.87C314.93 126.2 314.12 131.58 317.17 132.83C318.77 133.48 320.66 132.47 321.58 131.01C322.39 129.48 322.83 127.77 322.87 126.04C323.29 121.77 323.66 117.26 321.82 113.4C321.04 112.09 320.36 110.72 319.79 109.31C319.46 107.99 319.33 106.63 319.4 105.28C319.39 100.26 319.02 95.04 316.5 90.71C313.7 85.9 308.53 82.83 303.13 81.49C297.73 80.15 292.08 80.35 286.54 80.82C277.38 81.6 267.83 83.26 260.61 88.95C259.63 89.67 258.78 90.56 258.12 91.57C257.48 92.78 257.03 94.07 256.79 95.41C255.23 101.77 252.89 107.9 249.82 113.68C248.35 116.13 247.14 118.74 246.23 121.45C245.46 124.2 245.52 127.34 247.12 129.7C248.42 131.63 250.51 132.66 252.15 134.23C253.77 135.79 254.53 138.8 256.33 139.98C257.9 141.01 259.78 140.28 261.38 141.37C263.43 142.78 263.58 145.86 266 146.98C268.11 142.34 267.74 136.92 269.49 132.12Z",
    id: "b6vTsdGrGp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.39 218.58C293.19 214.98 294.19 212.98 294.39 212.58C294.39 212.58 338.38 225.58 347.37 237.58C347.37 237.58 369.37 223.58 381.36 225.58C382.16 225.71 386.16 226.38 393.36 227.58L356.37 260.57L309.39 256.57L291.39 218.58Z",
    id: "dBtJwxSAf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.4 212.58L248.41 269.56C283.8 286.96 303.46 296.62 307.39 298.55C307.39 298.55 312.9 301.55 317.14 298.55C319.76 297.35 332.83 291.36 356.37 280.56L393.36 227.58C371.17 238.98 358.84 245.31 356.37 246.57C356.37 246.57 352.37 238.58 344.38 242.57C337.04 238.58 318.72 228.58 289.4 212.58Z",
    id: "b24qU0jbR"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.37 313.55C357.17 300.95 359.84 293.96 360.37 292.56C360.37 292.56 378.36 269.56 368.37 258.57C368.37 258.57 347.37 290.56 347.37 290.56C348.04 293.62 349.71 301.29 352.37 313.55Z",
    id: "a4oLlnigZx"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.1 310.2C270.57 301.71 276.39 296.99 277.55 296.05C277.55 296.05 304.65 285.19 301.52 270.66C301.52 270.66 267.32 287.8 267.32 287.8C266.35 290.79 263.95 298.25 260.1 310.2Z",
    id: "ez3cnVyXB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.92 209.09C215.92 209.09 200.43 190.59 197.43 215.58C197.43 215.58 184.43 323.54 210.42 326.54C210.42 326.54 254.91 314.05 254.91 314.05C254.91 314.05 273.9 285.06 266.9 285.06C263.52 285.06 254.31 283.54 245.91 284.06C236.95 284.61 228.9 287.14 229.42 284.56C230.42 279.56 244.91 216.08 216.92 209.09C216.72 209.09 216.02 209.09 215.92 209.09Z",
    id: "b1xyi324iL"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.42 187.59C211.42 187.59 195.43 190.59 192.43 215.58C192.43 215.58 179.44 323.54 205.43 326.54C205.43 326.54 266.4 322.54 266.4 322.54C266.4 322.54 273.4 284.56 266.4 284.56C266.4 284.56 223.42 289.56 224.42 284.56C225.42 279.56 243.41 196.59 215.42 189.59C214.62 189.19 211.82 187.79 211.42 187.59Z",
    id: "laMyr0wJs"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.9 285.16L355.87 313.05L337.88 321.05L337.88 302.05L337.88 302.05L348.9 285.16Z",
    id: "b9nUV2XkK"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2Tsk0AARJ",
    opacity: 1,
    fill: "#3f3d56",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2Tsk0AARJ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3NwRIqT3m",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3NwRIqT3m",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a5R1J7OZEw",
    opacity: 1,
    fill: "#3f3d56",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a5R1J7OZEw",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4hIZDhWG3",
    opacity: 1,
    fill: "#6c63ff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4hIZDhWG3",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f2xuT3Z012",
    opacity: 1,
    fill: "#575a89",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f2xuT3Z012",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1C4xFZpkw",
    opacity: 1,
    fill: "#a0616a",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1C4xFZpkw",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c4ugWIHzTK",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c4ugWIHzTK",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aGeRUfuTL",
    opacity: 1,
    fill: "#2f2e41",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aGeRUfuTL",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e4jhw4gVS",
    opacity: 1,
    fill: "#2f2e41",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e4jhw4gVS",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aE2gm2KEo",
    opacity: 1,
    fill: "#2f2e41",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aE2gm2KEo",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gWOlvOa4F",
    opacity: 1,
    fill: "#a0616a",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gWOlvOa4F",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1xLFbJk8z",
    opacity: 1,
    fill: "#575a89",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1xLFbJk8z",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1tjoFzcBe",
    opacity: 1,
    fill: "#575a89",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1tjoFzcBe",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1hHoHK8AJ",
    opacity: 1,
    fill: "#575a89",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1hHoHK8AJ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b6vTsdGrGp",
    opacity: 1,
    fill: "#2f2e41",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b6vTsdGrGp",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dBtJwxSAf",
    opacity: 1,
    fill: "#f2f2f2",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dBtJwxSAf",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b24qU0jbR",
    opacity: 1,
    fill: "#6c63ff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b24qU0jbR",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4oLlnigZx",
    opacity: 1,
    fill: "#a0616a",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4oLlnigZx",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ez3cnVyXB",
    opacity: 1,
    fill: "#a0616a",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ez3cnVyXB",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1xyi324iL",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1xyi324iL",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#laMyr0wJs",
    opacity: 1,
    fill: "#575a89",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#laMyr0wJs",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b9nUV2XkK",
    opacity: 1,
    fill: "#575a89",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b9nUV2XkK",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReading);
export default __webpack_public_path__ + "static/media/reading.a0ac7c52f3fabe759b135e95456b9d77.svg";
export { ForwardRef as ReactComponent };